(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-daysomnia-v2"] && !Shopify.designMode) return;
  try {
    
(function(){
  function $(id){return document.getElementById(id);}
  function setText(id,t){var e=$(id); if(e) e.textContent=t;}
  function money(n){return '$'+n.toFixed(2);}

  // ---- gallery ----
  var slides=$('slides');
  if(slides){
    var imgs=slides.children, n=imgs.length, dots=$('dots'), thumbs=$('thumbs'), cur=$('cur');
    var srcs=[]; for(var i=0;i<n;i++){srcs.push(imgs[i].querySelector('img').src);}
    for(i=0;i<n;i++){(function(i){
      var d=document.createElement('i'); if(i===0)d.className='on'; dots.appendChild(d);
      var b=document.createElement('button'); b.setAttribute('aria-label','View image '+(i+1)); if(i===0)b.className='on'; b.innerHTML='<img src="'+srcs[i]+'" alt="">';
      b.onclick=function(){slides.scrollTo({left:i*slides.clientWidth,behavior:'smooth'});}; thumbs.appendChild(b);
    })(i);}
    slides.addEventListener('scroll',function(){
      var idx=Math.round(slides.scrollLeft/slides.clientWidth); idx=Math.max(0,Math.min(n-1,idx));
      cur.textContent=idx+1;
      [].forEach.call(dots.children,function(d,j){d.className=j===idx?'on':'';});
      [].forEach.call(thumbs.children,function(t,j){t.className=j===idx?'on':'';});
    },{passive:true});
  }

  // ---- variant select (updates price/sticky; the checked radio carries the id) ----
  function syncVariant(label){
    var all=document.querySelectorAll('.variant');
    for(var i=0;i<all.length;i++) all[i].classList.remove('on');
    label.classList.add('on');
    var radio=label.querySelector('input[name="id"]'); if(radio) radio.checked=true;
    var p=parseFloat(label.getAttribute('data-price'))||0, pf=money(p);
    setText('priceNow',pf); setText('atcPrice',pf); setText('sPrice',pf);
    var lab=label.getAttribute('data-label'); var nm=label.querySelector('.vname'); setText('sLabel', lab || (nm?nm.textContent.trim():''));
    setText('install','$'+(p/4).toFixed(2));
    var isDuo=(lab||'').indexOf('Duo')===0;
    var perUnit=isDuo?p/2:p; setText('perNight',(perUnit/60).toFixed(2)); setText('perNightEach',isDuo?' each':'');
    var ps=$('pay-single'), pd=$('pay-duo');
    if(ps) ps.style.display=isDuo?'none':''; if(pd) pd.style.display=isDuo?'':'none';
  }
  var labels=document.querySelectorAll('.variant');
  for(var k=0;k<labels.length;k++){(function(l){l.addEventListener('click',function(){syncVariant(l);});})(labels[k]);}

  // ---- add to cart (AJAX -> /cart/add.js fires product_added_to_cart -> GA4 add_to_cart) ----
  var form=$('pdp-form');
  function addToCart(){
    if(!form){return;}
    var fd=new FormData(form);
    fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(){ window.location.href='/cart'; })
      .catch(function(){ form.submit(); });
  }
  if(form){ form.addEventListener('submit',function(e){ e.preventDefault(); addToCart(); }); }
  var sAtc=$('sAtc'); if(sAtc){ sAtc.addEventListener('click',addToCart); }

  // ---- Add the Duo (separate bundle product, handle: daysomnia-duo) ----
  var addDuo=$('addDuo');
  if(addDuo){ addDuo.addEventListener('click',function(){
    fetch('/products/daysomnia-duo.js').then(function(r){return r.json();}).then(function(p){
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:p.variants[0].id,quantity:1})});
    }).then(function(){ window.location.href='/cart'; }).catch(function(){ window.location.href='/products/daysomnia-duo'; });
  }); }

  // ---- sticky bar reveal ----
  // first-screen fix 2026-06-24: show whenever the main ATC is OFF-screen (incl. on load,
  // when it sits below the fold), not only after you've scrolled past it. This keeps a
  // tappable "Add to Cart" present for the ~80% who bail before reaching the buy box.
  var sticky=$('sticky'), atc=$('atc');
  function updSticky(){
    if(!atc||!sticky){return;}
    var r=atc.getBoundingClientRect();
    var vh=window.innerHeight||document.documentElement.clientHeight;
    var inView=(r.top < vh) && (r.bottom > 0);
    sticky.classList.toggle('show', !inView);
  }
  window.addEventListener('scroll',updSticky,{passive:true});
  window.addEventListener('resize',updSticky); updSticky();

  // ---- reveal on scroll ----
  if('IntersectionObserver' in window){
    var ro=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in'); ro.unobserve(e.target);}});},{threshold:0,rootMargin:'0px 0px -8% 0px'});
    document.querySelectorAll('.pdp .reveal').forEach(function(el){ro.observe(el);});
  } else { document.querySelectorAll('.pdp .reveal').forEach(function(el){el.classList.add('in');}); }

  // ---- nav active + smooth ----
  var navLinks=document.querySelectorAll('#pdpNav a'), secs=[];
  navLinks.forEach(function(a){var s=document.querySelector(a.getAttribute('href')); if(s) secs.push({a:a,s:s});});
  window.addEventListener('scroll',function(){
    var y=window.scrollY+120, act=secs[0];
    secs.forEach(function(o){ if(o.s.offsetTop<=y) act=o; });
    navLinks.forEach(function(a){ a.classList.toggle('on', act && a===act.a); });
  },{passive:true});
})();

  } catch(e) { console.error(e); }
})();
})();
